<template>
  <section
    class="list"
    v-infinite-scroll="fetchNextPage"
    infinite-scroll-disabled="isInfinityScrollBusy"
    infinite-scroll-distance="10"
  >
    <div class="row">
      <div
        v-for="course in courses"
        :key="course.id"
        class="col-lg-4 col-md-4 col-xs-12 mb-4"
      >
        <CourseThumbBox :course="course" />
      </div>
    </div>

    <LoadingIcon v-if="isLoading" />
  </section>
</template>

<script>
  import { mapActions } from 'vuex'
  import infiniteScroll from 'vue-infinite-scroll'
  import CourseThumbBox from '@/components/course/CourseThumbBox'
  import LoadingIcon from '@/components/layout/LoadingIcon'

  export default {
    components: {
      CourseThumbBox,
      LoadingIcon
    },

    directives: { infiniteScroll },

    props: {
      courses: { type: Array, default: () => [] }
    },

    data: () => ({
      isLoading: false,
      isLastPage: false
    }),

    computed: {
      categoryId () {
        return this.courses.length ? this.courses[0].course_category_id : null
      },

      isInfinityScrollBusy () {
        return !this.courses.length || this.isLoading || this.isLastPage
      }
    },

    methods: {
      ...mapActions('course', ['fetchCoursesByCategory']),

      async fetchNextPage () {
        this.isLoading = true

        this.isLastPage = !await this.fetchCoursesByCategory(this.categoryId)

        this.isLoading = false
      }
    }
  }
</script>
